import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import './style.css'

const PageTitle = ({ Icon, title, subtitle }) => (
    <div className="coe__pageTitle">
        <Typography variant="h1" component="h2" id="top">
            <Icon color="primary" />
            { title }
        </Typography>
        {
            subtitle ?
                <Typography variant="subtitle2">
                    { subtitle }
                </Typography> :
                null
        }
    </div>
)

PageTitle.propTypes = {
    Icon: PropTypes.func,
    subtitle: PropTypes.oneOfType([ PropTypes.array, PropTypes.string ]),
    title: PropTypes.oneOfType([ PropTypes.array, PropTypes.string ])
}

export default PageTitle